import { AgencyId, Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { carrierAgencyRelationshipsQueryKey } from "../bond-request.keys";

export const useAdminFetchCarrierAgencyRelationships = (agencyId?: AgencyId) => {
	const { get } = useRequest();
	const { data, isLoading, error } = useQuery<Dtos.Admin.CarrierAgencyRelationships.Get.Response[]>(
		{
			queryKey: carrierAgencyRelationshipsQueryKey(agencyId),
			queryFn: async () => await get(`/v2/admin/agencies/${agencyId}/carriers`),
			enabled: !!agencyId,
		},
	);

	return {
		carrierAgencyRelationships: data,
		carrierAgencyRelationshipsLoading: isLoading,
		carrierAgencyRelationshipsError: error,
	};
};
